module.exports = __webpack_public_path__ + "static/media/iphonex_cropped.7d722197.png";